import config from '@/lib/config';
import { getSessionStorage, setSessionStorage } from '@/lib/utils/session-storage-utils';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

// this component will save REMEMBER_THIS_DEVICE over sessionStorage to allow 'auth' event to be able to read this value
// @FIX: we should refactor this flow to avoid using listeners to sign-in and manage it with a callback
const RememberDeviceField = () => {
	const [shouldRemember, setShouldRemember] = useState(false);

	const toggleShouldRemember = () => {
		setShouldRemember((old) => !old);
		toggleRememberThisDevice();
	};

	return (
		<Form.Group className="mb-0">
			<Form.Check
				id="remember-this-device"
				checked={shouldRemember}
				onChange={toggleShouldRemember}
				label={`Remember this device for ${config.HACKETT_USER_AUTH_REMEMBER_DEVICE_DURATION_IN_DAYS} days`}
				className="mt-2"
			/>
		</Form.Group>
	);
};

export default RememberDeviceField;

const REMEMBER_THIS_DEVICE = 'REMEMBER_THIS_DEVICE';
export const setRememberThisDevice = (shouldRemember: boolean) => {
	setSessionStorage(REMEMBER_THIS_DEVICE, shouldRemember.toString());
};

export const getRememberThisDevice = () => {
	const shouldRemember = getSessionStorage(REMEMBER_THIS_DEVICE);
	return shouldRemember === 'true';
};

const toggleRememberThisDevice = () => {
	const current = getRememberThisDevice();
	setRememberThisDevice(!current);
};
